import React from 'react';
import './index.less';
import classNames from 'classnames';

export interface IProps {
  style?: React.CSSProperties;
  className?: string;
}

class Min extends React.Component<IProps> {
  render() {
    const { children, className } = this.props;
    const classes = classNames('min-container', className);
    return <div className={classes}>{children}</div>;
  }
}

export default Min;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSContainer/Min/index.tsx